import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { TimeoutModalHOC } from '../auth';
const title = 'Still there?';
const message = 'We have not heard from you in awhile.  Would you like to remain logged in?';
export const testClassName = name => {
  return "Timeout-Modal-".concat(name);
};
export const DefiTimeoutModal = _ref => {
  let open = _ref.open,
    stay = _ref.stay,
    clock = _ref.clock,
    handleLogout = _ref.handleLogout;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: stay,
    "data-testid": testClassName('Dialog')
  }, /*#__PURE__*/React.createElement(DialogTitle, null, title), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, null, message)), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: stay,
    className: testClassName('Stay_Button')
  }, "Stay (".concat(clock, ")")), /*#__PURE__*/React.createElement(Button, {
    onClick: handleLogout,
    color: "primary",
    className: testClassName('Logout_Button')
  }, "Log Out")));
};
export default TimeoutModalHOC(DefiTimeoutModal);